import { lazy } from 'react';
import { Routes, SyncHook } from '../routeTypes';
import { useNavigateToCalls } from '../navigationHooks.util';

// Lazy load the CallsPage component
const CallsPage = lazy(() =>
  import('react-components/calls-page/CallsPage').then(module => ({
    default: module.default,
  }))
);

const CALLS_PATH = '/calls';

const routes: Routes = [
  {
    path: CALLS_PATH,
    element: <CallsPage />,
  },
];

const useSyncHook: SyncHook = null;

const useNavigationHooks = () => {
  const navigateToCalls = useNavigateToCalls();
  return {
    toCalls: (filters?: { onlyUnassignedCalls?: boolean }) => {
      navigateToCalls(filters);
    },
  };
};

export const callsPageRouteConfig = {
  routes,
  useSyncHook,
  useNavigationHooks,
};
